import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { ValidationError, ValidationResult } from '../../infrastructure/ValidationResult';
import { Opgavepakke } from '../../models/Opgavepakke';
import { getSkoleaarFromDate } from '../../models/SkoleAar';
import NotificationModule from '../../uiComponents/layout/Notification';
import EksternBrugerCreateNulstilPresenter from './EksternBrugerCreateNulstilPresenter';

export interface EksternBrugerNulstilContainerProps {
}

export interface EksternBrugerNulstilContainerState {
    email: string;
    validationResult: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
}

class EksternBrugerNulstilContainer extends React.Component<EksternBrugerNulstilContainerProps, EksternBrugerNulstilContainerState> {
    constructor(props: EksternBrugerNulstilContainer) {
        super(props);

        const opgavepakke = new Opgavepakke();
        opgavepakke.skoleaar = getSkoleaarFromDate(new Date());
        opgavepakke.opgavepakkeOpgaver = new Array();
        this.state = { email: '', isSaved: false, isSubmitting: false, validationResult: new ValidationResult() };

        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    onChange(fieldName: string, value: any) {
        const state = this.state;
        state[fieldName] = value;

        this.setState(state);
    }

    onSave() {
        const { email } = this.state;
        if (!this.validateEmail(email)) { return; }

        this.setState({ isSubmitting: true });
        const self = this;
        createApiCaller().createEksternBrugerPasswordResetRequest(this.state.email).then(response =>
            self.setState({ validationResult: response, isSaved: response.isValid, isSubmitting: false })
        );
    }

    validateEmail(email: string): boolean {
        const regex = /\S+@\S+\.\S+/;
        if (email === '') {
            const validationError = new ValidationError('email', 'Email skal udfyldes');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });

            return false;
        } else if (!regex.test(email)) {
            const validationError = new ValidationError('email', 'Email skal være en gyldig email');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });

            return false;
        }
        return true;
    }

    render() {
        if (this.state.isSaved) {
            NotificationModule.showSuccess('', 'Der er blevet sendt en nulstil adgangskode email til ' + this.state.email + ' hvis mailadressen findes i systemet', false);
            return <Redirect to='/emaillogin' />;
        } else {
            return (
                <EksternBrugerCreateNulstilPresenter
                    email={this.state.email}
                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                    onChange={this.onChange}
                    onSave={this.onSave}
                    isSubmitting={this.state.isSubmitting}
                    title='Glemt adgangskode'
                    header='Nulstil adgangskode'
                    submitBtnText='Nulstil'
                    backHref='/emaillogin'
                />
            );
        }
    }
}

export default EksternBrugerNulstilContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/eksternAdgang/EksternBrugerNulstilContainer.tsx